import Instafeed from 'instafeed.js';

document.addEventListener('DOMContentLoaded', () => {

    let counter = 0;
    const instagram_container = document.getElementById('instagram-feed');
    const getToken = new XMLHttpRequest();
    const token_url = 'https://ig.instant-tokens.com/users/141b87d3-51e5-4370-8d67-306fd392af60/instagram/17841400155557018/token?userSecret=blot13me9qqqpt7ak3j8t9';

    getToken.responseType = 'json';

    getToken.onloadstart = function() {
        instagram_container.innerHTML = '<div id="instagram-loader" class="col-span-full my-2 flex justify-center"><div class="loader"><span class="sr-only">Loading instagram images...</span</div></div>';
    }

    getToken.onload = function() {
        if (this.status >= 200 && this.status < 400) {

            // console.log(this.response)
            // console.log(this.response.Token);

            var feed = new Instafeed({
                accessToken: this.response.Token,
                target: instagram_container,
                limit: 5,
                template: '<a href="{{link}}" target="_blank" class="instagram-feed--item"><img title="{{caption}}" src="{{image}}" alt="An instagram post by {{username}} on {{timestamp}}"/><svg class="icon"><use href="#icon-instagram"/></svg></a>',
            });

            feed.run();

            // Remove loading indicator
            instagram_container.removeChild(document.getElementById('instagram-loader'));

        } else {
            console.error('Ran into an issue trying to get instagram token. More info should be below.')
            console.error(this.response);
        }
    }

    getToken.onerror = function() {
        console.error('Ran into an issue trying to get instagram token. More info should be below.')
        console.error(this.response);
    }

    if(instagram_container) {
        getToken.open('GET', token_url, true);

        getToken.send();
    }

});
